import { List } from 'immutable';
import { VisualTypes } from '../schema/visual-records';
import { ColumnSort, SortOrders } from '../schema/sort-records';
import { sortDataset } from 'reporting-visualizations/field/sort';
import { toVisualizationOrder } from '../modify/sorts/report-sort-utils';

/**
 * Applies a second sort on discrete dates that have been filled
 */
export const resort = (report, reportMeta, dataset) => {
  // ignore if there is no sort or visual is not a table
  const sort = (report.sorts || List()).first();
  if (!sort || !report.visual || report.visual.type !== VisualTypes.TABLE) {
    return dataset;
  }
  const sortColumn = sort && report.columns.get(sort.column);
  if (!sortColumn) {
    throw new Error(`Column alias not found: ${sort.column}`);
  }
  const visualOrder = toVisualizationOrder(sortColumn.set('sort', ColumnSort({
    priority: 0,
    type: sort.sortType,
    order: sort.order
  })), dataset).update('defined', defined => defined && sort.order === SortOrders.DESCENDING ? defined.reverse().toList() : defined);
  return sortDataset(dataset, sort.column, visualOrder);
};